<!--<div class="card">-->
<!--  <div class="card-body">-->
    <h5 class="card-title">{{title | translate}}</h5>
    <div class="p-3" *ngIf="!DisableEdit">
      <div class="d-flex justify-content-end" *ngIf="HasAddButton">
        <button class="btn btn-outline-info rounded-pill"  (click)="Add()" type="button">{{'Aggiungi' | translate}}</button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle " style="margin-bottom: 70px;">
        <thead>
        <tr>
          <th>Indirizzo</th>
          <th scope="col" [style]="campo.titleStyle" [class]="campo.titleClass" *ngFor="let campo of (CampiAggiuntivi ?? [])">{{ campo.nome | translate }}</th>
          <th scope="col" *ngIf="!DisableEdit" >Azioni</th>
        </tr>
        </thead>
        <tbody *ngIf="items">
            <tr  *ngFor="let item of items">
              <td class="align-middle">
                <span *ngIf="!item.modifica || !inLineEdit" >{{ item.fullAddress ?? item.indirizzo }}</span>
                <span *ngIf="item.modifica && inLineEdit">
                  <input [(ngModel)]="item.fullAddress" placeholder="Indirizzo" type="text" name="Indirizzo" class="form-control">
                </span>
              </td>
              <td class="align-middle" *ngFor="let campo of CampiAggiuntivi" >
                <ng-container *ngFor="let oggetto of (campo.oggetti ?? [])">
                  <span [style]="campo.style" [class]="campo.class" *ngIf="!campo.modificabile || !item.modifica || !inLineEdit ">
                    <span *ngIf="campo.icon" class="badge badge-light text-dark rounded-pill font-16 mr-1">
                      <i class="fas" [ngClass]="campo.icon"></i>
                    </span>
                    {{ campo.type == 'boolean' ? '' : item[oggetto] }}
                    <span *ngIf="campo.type == 'boolean'" [class.text-danger]="!item[oggetto]" [class.text-success] = "item[oggetto]" >
                      <i *ngIf="campo.type == 'boolean'" [class.far] ="!item[oggetto]" [class.fa-times-circle] ="!item[oggetto]" [class.fas] ="item[oggetto]" [class.fa-check-circle] ="item[oggetto]" ></i>
                    </span>
                  </span>
                  <span *ngIf="campo.modificabile && item.modifica && inLineEdit">
                    <input [(ngModel)]="item[oggetto]" [placeholder]="campo.nome" [type]="campo.inputType"  class="form-control">
                  </span>
                </ng-container>

              </td>
              <td class="align-middle" *ngIf="!DisableEdit" >
                <a *ngIf="(!item.modifica || !inLineEdit) && HasEditButton"  href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2"
                   (click)='edit(item)'>
                  <i-feather name="edit-3" class="feather-sm"></i-feather>
                </a>
                <a *ngIf="item.modifica && HasEditButton && inLineEdit" href="javascript:void(0)" ngbTooltip="Salva" class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>
                  <i-feather name="check" class="feather-sm"></i-feather>
                </a>
                <a *ngIf="!item.modifica && HasDeleteButton" href="javascript:void(0)" ngbTooltip="Elimina"
                   class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
                  <i-feather name="trash-2" class="feather-sm"></i-feather>
                </a>
                <a *ngIf="item.modifica && HasDeleteButton" href="javascript:void(0)" ngbTooltip="annulla"
                   class="link font-16 text-danger font-weight-bold" (click)='delete(item)'>
                  <i  class="fas fas fa-times"></i>
                </a>
                <a *ngIf="HasDuplicaButton" href="javascript:void(0)" ngbTooltip="Duplica"
                   class="link font-16 text-info font-weight-bold" (click)='duplicaClick(item)'>
                  <i class="fas fa-copy"></i>
                </a>
              </td>
            </tr>
        </tbody>
      </table>
    </div>
<!--  </div>-->
<!--</div>-->
